const getResolvedDetailsLinks = state => state.resolvedDetailsLinks

export {
  getResolvedDetailsLinks,
}
